import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }

  encrypt(text: any) {
    return CryptoJS.AES.encrypt(String(text), environment.encKey)
  }
  
  decrypt(text: any) {
    const bytes = CryptoJS.AES.decrypt(text, environment.encKey);
    const decryptText = bytes.toString(CryptoJS.enc.Utf8);
    return decryptText;
  }
}
